export default {
  Model: {
    ID: 'id',
    TYPE: 'type',
    TIME: 'time',
    USER_ID: 'userId',
    MEETING_ITEM_UUID: 'meetingItemUuid',
    WORKSPACE_SLUG: 'workspaceSlug',
    DATA: 'data',
    ASSIGNEE_NAME: 'assigneeName',
    WORKSPACE_COMMENT_UUID: 'workspaceCommentUuid',
    IS_NEW: 'isNew',
  },
  Actions: {
    FETCH_RECENT_UPDATES_SUCCESS: 'workspaces/FETCH_RECENT_UPDATES_SUCCESS',
  },
  State: {
    WORKSPACES_RECENT_UPDATES_BY_ID: 'WORKSPACES_RECENT_UPDATES_BY_ID',
  },
};
